<template>
  <div id="leftMediaCardRoot">
    <div id="container">
      <div id="mediaContainer">
        <img :style="'height:'+ mediaHeight + ';' + 'width:'+ width" v-if="image" :src="require('../../assets/' + image)" @contextmenu.prevent/>
        <video :style="'object-position: 50%'+ mediaOffset + ';' + 'width:'+ width" v-if="video" @contextmenu.prevent autoplay loop playsinline muted>
          <source :src="require('../../assets/' + video)" type="video/mp4"/>
        </video>
      </div>

      <div id="infoContainer">
        <span id="title" v-html="title"></span>
        <span id="description" v-html="description"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeftMediaCard",
  props: {
    height: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    background: {
      type: String,
      default: ""
    },
    video: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    },
    mediaOffset: {
      type: String,
      default: "50%"
    },
    width: {
      type: String,
      default: "100%"
    },
    mediaHeight: {
      type: String,
      default: "100%"
    },
  },
}
</script>

<style lang="scss" src="../../styles/blog/leftmediacard.scss" scoped/>